import { render, staticRenderFns } from "./MrbList.vue?vue&type=template&id=e6660116"
import script from "./MrbList.vue?vue&type=script&lang=js"
export * from "./MrbList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports